module.exports = __webpack_public_path__ + "static/img/卡片-选中背景_image@2x.9b822373.png";